import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import SideNavItem from './item/item';

import { SiteIcon } from 'assets/icons';

import styles from './side-nav.module.css';

const SideNav = (props) => {
  const { open_tray, onTrayClose } = props;
  const veil = useRef();

  useEffect(() => {
    if (open_tray) {
      openMenuTray();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open_tray]);

  const closeMenuTray = () => {
    const tray = veil.current;
    let tray_left = 0;
    fadeOutTrayBackground();
    const slideOutAmination = setInterval(() => {
      if (tray_left > 100) {
        tray.style.left = '100%';
        clearInterval(slideOutAmination);
        onTrayClose();
        return;
      }

      tray_left += 10;
      tray.style.left = `-${tray_left}%`;
    }, 20);
  };

  const fadeInTrayBackground = () => {
    const tray = veil.current;
    let opacity = 0;
    const fadeInAnimation = setInterval(() => {
      if (opacity > 0.3) {
        tray.style.background = 'rgba(0, 0, 0, 0.35)';
        clearInterval(fadeInAnimation);
        return;
      }

      opacity += 0.1;
      tray.style.background = `rgba(0, 0, 0, ${opacity})`;
    }, 10);
  };

  const fadeOutTrayBackground = () => {
    const tray = veil.current;
    let opacity = 0.35;
    const fadeOutAnimation = setInterval(() => {
      if (opacity < 0) {
        tray.style.background = 'rgba(0, 0, 0, 0)';
        clearInterval(fadeOutAnimation);
        return;
      }

      opacity -= 0.1;
      tray.style.background = `rgba(0, 0, 0, ${opacity})`;
    }, 10);
  };

  const openMenuTray = () => {
    const tray = veil.current;
    let tray_left = 100;
    tray.style.background = 'rgba(0, 0, 0, 0)';
    const slideInAmination = setInterval(() => {
      if (tray_left < 0) {
        tray.style.left = 0;
        fadeInTrayBackground();
        clearInterval(slideInAmination);
        return;
      }

      tray_left -= 10;
      tray.style.left = `-${tray_left}%`;
    }, 20);
  };

  return (
    <nav className={styles.sideNavWrapper} ref={veil} onClick={() => closeMenuTray()}>
      <div className={styles.appSideNav} onClick={(e) => e.stopPropagation()}>
        <header>
          <Link to="/dashboard" className={styles.link}>
            <span className={styles.siteIcon}>
              <SiteIcon width={48} height={24} />
            </span>
            <span className={styles.siteName}>Flagly</span>
          </Link>
        </header>
        {/* <CreateButton actions={icon_new_actions} handleUserAction={handleUserAction} /> */}
        <section>
          <SideNavItem title="Flags" name="extension" path="/flags" onItemClick={closeMenuTray} />
          <SideNavItem title="Logs" name="dashboard" path="/logs" onItemClick={closeMenuTray} />
          <SideNavItem title="Sentry" name="show" path="/sentries" onItemClick={closeMenuTray} />
          <SideNavItem title="Users" name="people" path="/users" onItemClick={closeMenuTray} />
          <SideNavItem
            title="Settings"
            name="settings"
            onItemClick={closeMenuTray}
            path="/settings"
          />
        </section>
      </div>
    </nav>
  );
};

export default SideNav;
